import type { ApiClient } from "../../../infrastructure/http/apiClient";
import type {
  Appointment,
  CancelAppointmentInput,
  CreateAppointmentInput,
  ListAppointmentsInput,
  UpdateAppointmentInput
} from "../domain/appointment";

export function loadAppointmentsForWindow(apiClient: ApiClient, input: ListAppointmentsInput): Promise<Appointment[]> {
  const params = new URLSearchParams({
    start: input.start.toISOString(),
    end: input.end.toISOString()
  });

  if (input.resourceID) {
    params.set("resource_id", input.resourceID);
  }

  return apiClient.get<Appointment[]>(`/api/v1/appointments?${params.toString()}`);
}

export function createAppointment(apiClient: ApiClient, input: CreateAppointmentInput): Promise<Appointment> {
  return apiClient.post<Appointment, CreateAppointmentInput>("/api/v1/appointments", input);
}

export function updateAppointment(apiClient: ApiClient, appointmentID: string, input: UpdateAppointmentInput): Promise<Appointment> {
  return apiClient.patch<Appointment, UpdateAppointmentInput>(`/api/v1/appointments/${appointmentID}`, input);
}

export function confirmAppointment(apiClient: ApiClient, appointmentID: string): Promise<Appointment> {
  return apiClient.post<Appointment, Record<string, never>>(`/api/v1/appointments/${appointmentID}/confirm`, {});
}

export function cancelAppointment(apiClient: ApiClient, appointmentID: string, input: CancelAppointmentInput): Promise<Appointment> {
  return apiClient.post<Appointment, CancelAppointmentInput>(`/api/v1/appointments/${appointmentID}/cancel`, input);
}
